module.exports = __webpack_public_path__ + "static/media/expired.552d1731.svg";